import Vue from 'vue'
import DateFormatter from '@/classes/DateFormatter'

Vue.filter('formatDateTime', (value: any, defaultValue = '/') => {
  if (value) {
    const dateFormatter = new DateFormatter()
    return dateFormatter.setFormat('MM/DD/YY hh:mm A').get(value)
  } else {
    return defaultValue
  }
})

Vue.filter('formatDate', (value: any, defaultValue = '/', format = 'MM/DD/YY') => {
  if (value) {
    const dateFormatter = new DateFormatter()
    return dateFormatter.setFormat(format).get(value)
  } else {
    return defaultValue
  }
})
